import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root',
})
export class FunnelAnalyticsService {
  constructor(private analytics: AnalyticsService) {}

  /* -----------------------------
   * FUNNEL STEP EVENTS
   * ----------------------------- */

  init(funnel: string, step: number, stepName: string) {
    this.analytics.trackEvent('funnel_step_init', {
      funnel,
      step,
      step_name: stepName,
    });
  }

  enterStep(funnel: string, step: number, stepName: string) {
    this.analytics.trackEvent('funnel_step_enter', {
      funnel,
      step,
      step_name: stepName,
    });
  }

  completeStep(funnel: string, step: number, stepName: string) {
    this.analytics.trackEvent('funnel_step_complete', {
      funnel,
      step,
      step_name: stepName,
    });
  }

  abandonStep(funnel: string, step: number, stepName: string) {
    this.analytics.trackEvent('funnel_step_abandon', {
      funnel,
      step,
      step_name: stepName,
    });
  }

  /* -----------------------------
   * PAYMENT EVENTS
   * ----------------------------- */

  /** User initiates payment */
  paymentInit(
    funnel: string,
    paymentMethod: string,
    amount: string | number,
    currency: string,
  ) {
    this.analytics.trackEvent('payment_init', {
      funnel,
      payment_method: paymentMethod,
      value: amount,
      currency,
    });
  }

  /** Payment successful */
  paymentComplete(
    funnel: string,
    paymentMethod: string,
    amount: number,
    currency: string = 'USD',
  ) {
    this.analytics.trackEvent('payment_complete', {
      funnel,
      payment_method: paymentMethod,
      value: amount,
      currency,
    });
  }

  /** Payment failed or cancelled */
  paymentFailed(
    funnel: string,
    paymentMethod: string,
    reason: string,
    errorCode?: string,
  ) {
    this.analytics.trackEvent('payment_failed', {
      funnel,
      payment_method: paymentMethod,
      failure_reason: reason,
      error_code: errorCode,
    });
  }
}
